// import { ToggleSwitch } from "flowbite-react"
import st from "overrides/theme/entel/base/components/Custom/Switch/LabelSwitch.module.css"
import { Fragment, useRef } from "react"
import cn from "classnames"
import ReactTooltip from "react-tooltip"

interface ISwitch {
  checked: boolean
  onChange: () => void
  label: string
  className?: string
  tool_msg?: string
}

const Switch = ({ checked, onChange, label, className, tool_msg }: ISwitch) => {
  const ref_switch: any = useRef(null)
  return (
    <Fragment>
      <ReactTooltip />
      <div className={cn("flex flex-row items-center justify-start gap-2 label_switch__switch__container", className)} data-tip={tool_msg}>
        <label className={st["label_switch__switch"]}>
          <input ref={ref_switch} type="checkbox" checked={checked} onChange={onChange} />
          <span className={`${st["label_switch__slider"]} ${st["label_switch__round"]}`}></span>
        </label>
        <p onClick={() => ref_switch?.current?.click()} className="cursor-pointer">
          {label}
        </p>
      </div>
    </Fragment>
  )
}

export default Switch
